import { ApiObjectHandler } from './abstract-handler';

import * as Types from '../../../types';

export class WebspaceHandler extends ApiObjectHandler<Types.WebhostingApi.Webspace> {}
